import { Box, Theme, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router-dom';

type HeaderSubNavItem = {
 labelKey: string;
 path: string;
};

const HEADER_SUB_NAV: Record<string, HeaderSubNavItem[]> = {
 products: [
  { labelKey: 'entities.products', path: '/products' },
  { labelKey: 'entities.products/groups', path: '/products/groups' },
 ],
 destPoint: [
  { labelKey: 'entities.destPoint', path: '/destPoint' },
  { labelKey: 'entities.destPoint/details', path: '/destPoint/details' },
 ],
};

const titleSx = {
 fontSize: { xs: 14, md: 16 },
 fontWeight: 500,
 color: (theme: Theme) => theme.palette.kemek.darkestGray,
};

const HeaderSubNav = ({ headerTitle }: { headerTitle: string }) => {
 const { t } = useTranslation();
 const location = useLocation();

 const groupKey = location.pathname.split('/')[1];
 const items = HEADER_SUB_NAV[groupKey];

 if (!items) {
  return (
   <Typography component="h1" sx={titleSx}>
    {headerTitle}
   </Typography>
  );
 }

 const otherItems = items.filter((item) => location.pathname !== item.path);

 return (
  <Box
   component="nav"
   aria-label="page sub-navigation"
   sx={{
    display: 'flex',
    flexDirection: { xs: 'column', md: 'row' },
    alignItems: { xs: 'flex-start', md: 'center' },
    gap: { xs: '4px', md: '20px' },
   }}
  >
   <Typography component="h1" sx={titleSx} aria-current="page">
    {headerTitle}
   </Typography>

   {otherItems.map((item) => (
    <Box
     key={item.path}
     sx={{ display: 'flex', alignItems: 'center', gap: '12px' }}
    >
     <Link to={item.path} style={{ textDecoration: 'none' }}>
      <Box
       sx={{
        fontSize: { xs: 14, md: 16 },
        fontWeight: 500,
        color: (theme: Theme) => theme.palette.kemek.blue,
        '&:hover': {
         textDecoration: 'underline',
        },
       }}
      >
       {t(item.labelKey)}
      </Box>
     </Link>
    </Box>
   ))}
  </Box>
 );
};

export default HeaderSubNav;
